import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import IconButton from '../buttons/icon-button'
import ImgCover from '../utilities/img-cover'

const UploadImgItem = props => (
  <div
    className={classNames({
      'upload-img': true,
      [props.className]: props.className
    })}
  >
    <ImgCover src={props.src} className='thumbnail' alt={props.alt} />
    <span className='filename'>{props.filename}</span>
    <IconButton iconName='delete-bin' type='button' onClick={props.onClick} />
  </div>
)

UploadImgItem.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  filename: PropTypes.string,
  onClick: PropTypes.func
}

export default UploadImgItem



// WEBPACK FOOTER //
// ./src/ui/lists/upload-img-item.js